import React, { useState } from 'react';

interface BalanceCardProps {
  onButtonClick: () => void;
}

const BalanceCard: React.FC<BalanceCardProps> = ({ onButtonClick }) => {
  const [isCustomAmount, setIsCustomAmount] = useState(false);
  const [customAmount, setCustomAmount] = useState<string>('0.00');

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      {/* Header */}
      <div className="bg-teal-700 text-white p-6">
        <h3 className="text-xl font-bold">Mi Saldo</h3>
        <p className="text-teal-100">Resumen de mi Estado de Cuenta</p>
      </div>

      {/* Content */}
      <div className="p-6">
        {/* TecMilenio branding */}
        <div className="text-center mb-6">
          <span className="text-gray-600 font-medium">TecMilenio</span>
        </div>

        {/* Balance information */}
        <div className="space-y-4 mb-8">
          <div className="flex justify-between items-center">
            <span className="text-gray-700">Saldo total</span>
            <span className="font-bold text-lg">$27,997.49</span>
          </div>
          
          <div className="flex justify-between items-center">
            <div>
              <span className="text-gray-700">Saldo a pagar</span>
              <div className="text-sm text-gray-500">para no generar intereses</div>
            </div>
            <span className="font-bold text-lg">$27,997.49</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-700">Fecha de corte</span>
            <span className="font-medium">30-Abril-26</span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-gray-700">Fecha límite de pago</span>
            <span className="font-medium">15-Mayo-26</span>
          </div>
        </div>

        {/* Account statement link */}
        <div className="text-center mb-8">
          <button 
            onClick={onButtonClick}
            className="text-teal-600 hover:text-teal-700 underline font-medium"
          >
            Ver estado de cuenta
          </button>
        </div>

        {/* Payment section */}
        <div className="border-t pt-6">
          <h4 className="font-bold text-gray-800 mb-4">Pagar</h4>
          
          <div className="space-y-4 mb-6">
            <label className="flex items-center space-x-3">
              <input
                type="radio"
                name="paymentType"
                checked={!isCustomAmount}
                onChange={() => setIsCustomAmount(false)}
                className="text-teal-600"
              />
              <span>Total a pagar:</span>
            </label>
            <div className="ml-6 font-bold text-lg">$27,997.49</div>
            
            <label className="flex items-center space-x-3">
              <input
                type="radio"
                name="paymentType"
                checked={isCustomAmount}
                onChange={() => setIsCustomAmount(true)}
                className="text-teal-600"
              />
              <span>Otra cantidad <span className="text-gray-500 text-sm">MXN</span></span>
            </label>
            
            {isCustomAmount && (
              <div className="ml-6">
                <input
                  type="text"
                  value={customAmount}
                  onChange={(e) => setCustomAmount(e.target.value)}
                  className="border border-gray-300 rounded px-3 py-2 w-32"
                  placeholder="0.00"
                />
              </div>
            )}
          </div>

          {/* Action buttons */}
          <div className="flex space-x-4">
            <button 
              onClick={onButtonClick}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 py-3 px-6 rounded-lg font-semibold transition-colors"
            >
              Domiciliar
            </button>
            <button 
              onClick={onButtonClick}
              className="flex-1 bg-teal-600 hover:bg-teal-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors"
            >
              Proceder al pago
            </button>
          </div>

          {/* Footer info */}
          <div className="mt-4 text-center text-sm text-gray-500">
            Vigencia de consulta: 24/04/2026 11:09:51
          </div>
        </div>
      </div>
    </div>
  );
};

export default BalanceCard;